import {Component} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import { BUSINESS_PROCESS_LAYER_ID, DagreNodesOnlySettings, Orientation } from '../../models/graph-kn.cm-api-models';
import { GraphKnDataService } from '../../services/graph-kn.data.service'
import { MatDialogRef } from '@angular/material/dialog';
import { graphDefaultSettings } from '../../models/graph-kn.cm.model-const';

@Component({
    selector: 'app-graph-settings-form',
    templateUrl: './graph-settings-form.component.html',
    styleUrl: './graph-settings-form.component.scss'
})
export class AppGraphSettingsFormComponent {
	private defaultSettings = graphDefaultSettings
	public algorithmsList:{package:string,algorithm:string}[]=[
		{package:'dagre',algorithm:'network-simplex'},
		{package:'dagre',algorithm:'tight-tree'},
		{package:'dagre',algorithm:'longest-path'},
		{package:'ELK',algorithm:'layered'},
		{package:'ELK',algorithm:'mrtree'},
	]
	public graphSettings!: FormGroup
	constructor(
		private knDataService:GraphKnDataService,
		private fb: FormBuilder,
		private dialogRef: MatDialogRef<AppGraphSettingsFormComponent>,
	) {
	}
	ngOnInit(): void {
		let currentSettings = this.knDataService.layoutDagreSettings.get(BUSINESS_PROCESS_LAYER_ID)
		this.graphSettings = this.fb.group({
			package: [currentSettings?.module||this.defaultSettings.module, {validators: [Validators.required]}],
			algorithm: [currentSettings?.ranker || this.defaultSettings.ranker, {validators: [Validators.required]}],
			algorithmEdges: [currentSettings?.algorithmEdges || this.defaultSettings.algorithmEdges, {validators: [Validators.required]}],
			edgeType: [currentSettings?.edgeType || this.defaultSettings.edgeType, {validators: [Validators.required]}],
			pointerType: [currentSettings?.pointerType || this.defaultSettings.pointerType, {validators: [Validators.required]}],
			orientation: [currentSettings?.orientation || this.defaultSettings.orientation, {validators: [Validators.required]}],
			rankPadding: [currentSettings?.rankPadding || this.defaultSettings.rankPadding, {validators: [Validators.required]}],
			nodePadding: [currentSettings?.nodePadding || this.defaultSettings.nodePadding, {validators: [Validators.required]}],
		})
	}
	drawGraphByNewSettings() {
		let currentSettings = this.knDataService.layoutDagreSettings.get(BUSINESS_PROCESS_LAYER_ID)
		let newSettings: DagreNodesOnlySettings ={
			orientation:(this.orientation?.value || this.defaultSettings.orientation as Orientation),
			algorithmEdges:(this.algorithmEdges?.value || this.defaultSettings.algorithmEdges),
			rankPadding: this.rankPadding?.value || this.defaultSettings.rankPadding,
			nodePadding: this.nodePadding?.value || this.defaultSettings.nodePadding,  
			ranker: this.algorithm?.value || this.defaultSettings.ranker,
			edgeType: this.edgeType?.value || this.defaultSettings.edgeType,
			pointerType: this.pointerType?.value || this.defaultSettings.pointerType,
			marginX:currentSettings?.marginX,
			marginY:currentSettings?.marginY,
			module:this.package?.value||this.defaultSettings.module
		}
		this.knDataService.subGraphSettingsChangesd$.next([BUSINESS_PROCESS_LAYER_ID,newSettings])
		this.dialogRef.close()
	}
	get package() {return this.graphSettings.get('package')}
	get algorithm() {return this.graphSettings.get('algorithm')}
	get algorithmEdges() {return this.graphSettings.get('algorithmEdges')}
	get edgeType() {return this.graphSettings.get('edgeType')}
	get pointerType() {return this.graphSettings.get('pointerType')}
	get orientation() {return this.graphSettings.get('orientation')}
	get rankPadding() {return this.graphSettings.get('rankPadding')}
	get nodePadding() {return this.graphSettings.get('nodePadding')}
}
